import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SEO from '../components/SEO';

const PageNotFound: React.FC = () => {
  return (
    <SEO title="Page not found" description="">
      <Container>
        <Row>
          <Col>
            <h1 className="text-center">Page not found!</h1>
          </Col>
        </Row>
      </Container>
    </SEO>
  );
}

export default PageNotFound;
